export default {
  GET_MESSAGE_SENDERS_REQUEST: '@@message-senders/GET_MESSAGE_SENDERS_REQUEST',
  GET_MESSAGE_SENDERS_SUCCESS: '@@message-senders/GET_MESSAGE_SENDERS_SUCCESS',
  GET_MESSAGE_SENDERS_ERROR: '@@message-senders/GET_MESSAGE_SENDERS_ERROR',

  FLUSH_MESSAGE_SENDERS_ALL_STATE: '@@message-senders/FLUSH_MESSAGE_SENDERS_ALL_STATE',
};
